<template>
  <CardComponent :show-title="false">
    <LeadListComponent
      height="500px"
      :headers="headers"
      :leads="leads"
      @accept="onAccept"
      @decline="onDecline"
      @click:row="onClick"
    />
  </CardComponent>
</template>

<script>
import LeadListComponent from "@/components/lead/LeadListComponent";
import CardComponent from '../components/form/CardComponent'

export default {
  name: "LeadListView",
  components: {
    CardComponent,
    LeadListComponent},
  setup(_, context) {
    const headers = [
      {
        text: 'Annehmen',
        value: 'accept',
        type: LeadListComponent.columnTypes.ACCEPT,
        verticalSeparator: true
      },
      {
        text: 'Ablehnen',
        value: 'decline',
        type: LeadListComponent.columnTypes.DECLINE,
      },
      {
        text: 'Firma',
        value: 'company',
        type: LeadListComponent.columnTypes.TEXT
      },
      {
        text: 'Verfügbar seit',
        value: 'availableSince',
        type: LeadListComponent.columnTypes.DATE,
        sortingIcon: LeadListComponent.sorting.DSC,
      },
      {
        text: 'Adresse',
        value: 'address',
        type: LeadListComponent.columnTypes.TEXT
      },
      {
        text: 'Telefon',
        value: 'phone',
        type: LeadListComponent.columnTypes.TEXT,
        color: '#dd227b'
      },
      {
        text: 'Email',
        value: 'email',
        type: LeadListComponent.columnTypes.TEXT
      }
    ]


    let leads = []
    const testLead = {
      accept: '',
      decline: '',
      company: 'Shulzen & So GmbH',
      availableSince: new Date(2020, 8, 28, 9, 38),
      address: 'Königsweg 23, 46455 Döbeln',
      phone: '025163635456',
      email: 'ian.kroeger@shulzen.de',
      link: 'pipeline-view',
    }
    for (let i = 0; i < 100; i++){
      leads = [...leads, {...testLead, id:i}]
    }

    leads[0].clickable = true
    leads[2].clickable = true
    leads[4].clickable = true
    leads[5].clickable = true

    function onAccept(lead){
      console.log('Accepted: ', lead)
    }
    function onDecline(lead){
      console.log('Declined: ', lead)
    }

    const router = context.root.$router
    function onClick(lead){
      router.push({
        path: lead.link,
        query: {id: lead.id}
      })
    }
    return {leads, headers, onAccept, onDecline, onClick}
  }
}
</script>

<style scoped>

</style>
